import { Suspense } from 'react';

const Loadable = (Component) => {
  const WrappedComponent = (props) => (
    <Suspense fallback={<div></div>}>
      <Component {...props} />
    </Suspense>
  );
  WrappedComponent.displayName = `Loadable(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};

export default Loadable;